import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {UserSubscription} from "../../../../user/user-subscription";
import {Router} from "@angular/router";
import {clientRoles} from "../../../../user/user-roles-actions";
import {UserSubscriptionStatus} from "../../../../user/user-subscription-status";
import {PaymentMethod} from "../../../../user/payment-method";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import * as fromStore from "../../../../store";
import {Store} from "@ngrx/store";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {BuilderSectionsInteractionService} from "../../../../builder-v2/builder-sections-interaction.service";
import {Subject} from "rxjs";

@Component({
    selector: 'db-subscription-plan-details',
    templateUrl: './subscription-plan-details.component.html',
    styleUrl: './subscription-plan-details.component.scss',
    standalone: false
})
export class SubscriptionPlanDetailsComponent implements OnInit {
  @Input('userSubscription') set userSub(userSubscription: UserSubscription) {
    this.userSubscription = userSubscription;
    const features = this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.shortFeatures;
    this.upgradeLimitPassed = !!(this.upgradeLimit && this.upgradeLimit[features.tabCategory] && this.upgradeLimit[features.tabCategory][features.hostingPlanCategory]) || features.hostingPlanCategory === 'enterprise';
    this._getBillingProgress(this.userSubscription?.apiResellerFree ? this.userSubscription?.hostingTrialExpireDate?.toString() : this.userSubscription.nextBillingDate?.toString() || this.userSubscription.expireDate?.toString());
  }

  @Input() userLocalStorage: any;
  @Input() currentWorkspaceRole: number;
  @Input() activateClicked: boolean;
  @Input() hasUpgrade: boolean;
  @Input() paymentMethods: PaymentMethod[];

  @Output() onAddWebsite: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancelSub: EventEmitter<void> = new EventEmitter<void>();
  @Output() unpause?: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() activateUserSubscription?: EventEmitter<UserSubscription> = new EventEmitter<UserSubscription>();
  @Output() onRetryUserSubscription?: EventEmitter<UserSubscription> = new EventEmitter<UserSubscription>();
  @Output() onAddPaymentMethod?: EventEmitter<boolean> = new EventEmitter<boolean>();
  private _router = inject(Router);

  userSubscription: UserSubscription;
  daysUntilNext: number;
  percentageLeft: number;
  userSubscriptionStatus = UserSubscriptionStatus;
  workspaceRoles = clientRoles;
  isMobile = window.innerWidth <= 991;
  UserSubscriptionStatus = UserSubscriptionStatus;
  upgradeLimitPassed = false;
  upgradeLimit = {
    agency: {
      personal: false,
      premium: true,
      enterprise: true,
    }
  };
  usedAiCredits$ = this._store.select(fromStore.selectUsedAiCredits);
  vibeLimitationData: any;
  companyName: string = 'Dashboard';
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(private _store: Store<fromStore.DbStoreState>,
              private _builderSectionsInteractionService: BuilderSectionsInteractionService ) {
  }


  ngOnInit() {
    this._getCompanyInfo();
  }

  private _getCompanyInfo(): void {
    this._builderSectionsInteractionService.companyInfo
        .pipe(
            filter(companyInfo => !!companyInfo),
            takeUntil(this._destroyStream$),
            first()
        )
        .subscribe(companyInfo => {
          this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
        });
  }
  private _getBillingProgress(nextBillingDate: string) {
    const currentDate = new Date();
    const nextDate = new Date(nextBillingDate);

    // Calculate days until next billing date
    this.daysUntilNext = Math.ceil((nextDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));
    const freeDays = (Math.ceil((nextDate.getTime() - (TypeUtils.isDefined(this.userLocalStorage['extend_agreement']) ? currentDate.getTime() : this.userSubscription.agreementDate.getTime()))) / (1000 * 60 * 60 * 24));

    // Calculate percentage left
    this.percentageLeft = (this.daysUntilNext / freeDays) * 100;
    this._store.select(fromStore.getVibeLimitationsLoaded)
        .pipe(
            filter((loaded: boolean) => loaded),
            switchMap(() => this._store.select(fromStore.getVibeLimitationsData)),
            first()
        )
        .subscribe((limitations: any) => {
          this.vibeLimitationData = {
            planLimit: limitations?.edit_limitations?.limitation,
            alreadyUsed: limitations?.edit_limitations?.already_used,
            additionalCredits: limitations?.additional_credits?.total_credits || 0
          };
        });
  }

  onUpgradeClick() {
    this._router.navigate(['/upgrade-plan'], {queryParams: {currentUser: true}});
  }


  activateSubscription(userSubscription: UserSubscription) {
    this.activateUserSubscription.emit(userSubscription);
  }

  renewSubs() {
    this.unpause.next(true);
  }
}
